import type { LinguisticIndicator } from '../lib/types';
import { InfoPopover } from './InfoPopover';
import { clamp } from '../lib/format';
import styles from './LinguisticIndicatorTile.module.css';

export function LinguisticIndicatorTile({ ind, className }: { ind: LinguisticIndicator; className?: string }) {
  const pct = clamp(ind.rawValue, 0, 1) * 100;
  return (
    <div className={[styles.tile, className].filter(Boolean).join(' ')}>
      <div className={styles.head}>
        <span className={styles.label}>{ind.label}</span>
        {ind.tooltip && <InfoPopover content={<span>{ind.tooltip}</span>} label={`What is ${ind.label}?`} />}
      </div>
      <span className={[styles.value, 'mono'].join(' ')}>{ind.value}</span>
      <div className={styles.bar}>
        <div className={styles.barFill} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
